export default __webpack_public_path__ + "static/media/research.abac601c.png";